import React from 'react';
import { NavLink } from 'react-router-dom';

// Define the props for SidebarItem
interface SidebarItemProps {
    to: string;
    icon: React.ReactElement;
    label: string;
}

const SidebarItem: React.FC<SidebarItemProps> = ({ to, icon, label }) => {
    return (
        <li className="h-[50px]">
            <NavLink
                to={to}
                className={({ isActive }) =>
                    `flex items-center text-base space-x-3 p-2 w-full h-full rounded ${
                        isActive
                            ? 'text-[#04E1CF]'
                            : 'text-white hover:text-[#04E1CF]'
                    }`
                }
            >
                {icon}
                <span>{label}</span>
            </NavLink>
        </li>
    );
};

export default SidebarItem;